import '~/js/views/general/includes/scroll-below';
import Select from '~/js/modules/custom-select';

new Select($('#js-resort-select'), 'All Resorts', false);


function SortActivities() {
    this.selectMenu = document.querySelector('#js-resort-select');
    this.selectModulMenu = document.querySelector('#js-resort-select-menu');
    this.selectModulButton = document.querySelector('#js-resort-select-button');
    this.activities = document.querySelectorAll('.ls-activities__item');
    this.titleSort = document.querySelector('.ls-activities__list-title');
    this.titleSort.innerHTML = 'all activities at sandals';

    this._events = () => {
        this.selectModulButton.addEventListener('click', () => {
            for(let i = 0; i < this.selectMenu.children.length; i++) {
                if(!this.selectMenu.children[i].dataset.href) {
                    this.selectModulMenu.children[i].classList.add('ui-selectmenu-optgroup');
                    this.selectModulMenu.children[i].children[0].classList.remove('ui-menu-item-wrapper');
                }
                if(!this.selectMenu.children[i].dataset.href && i > 0) {
                    this.selectModulMenu.children[i].classList.remove('ui-menu-item');
                }
            }
        });

        this.selectModulMenu.addEventListener('click', e => {
            for(let i = 0; i < this.selectMenu.children.length; i++) {
                if(e.target === this.selectModulMenu.children[i].children[0] && this.selectMenu.children[i].value ) {

                    this.titleSort.innerHTML = `included at ${this.selectMenu.children[i].innerHTML}`;

                    for(let j = 0; j < this.activities.length; j++) {
                        if (this.activities[j].dataset.resorts.split(', ').indexOf(this.selectMenu.children[i].value) >= 0 ) {
                            this.activities[j].classList.remove('ls-activities__item--hide');
                        } else {
                            this.activities[j].classList.add('ls-activities__item--hide');
                        }
                    }
                }
            }
        });
    };

    this._init = () => {
        this._events();
    };

    this._init();
}

const sortActivities = new SortActivities();
